// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { FeatherstoneHealthcheckAPIResponse } from '../types';

const { REACT_APP_FEASY_API_URL } = process.env;

// Define a service using a base URL and expected endpoints
export const featherstoneApi = createApi({
  reducerPath: 'featherstoneApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${REACT_APP_FEASY_API_URL}/`,
  }),
  endpoints: (builder) => ({
    // TODO :: proper typing
    getCounts: builder.mutation<any, any>({
      query: ({ custom_variables, variables, weight }) => ({
        url: `/counts/`,
        method: 'POST',
        // TODO :: proper body
        body: {
          // required
          panel_id: 1,
          country_of_residence: 'us',
          custom_variables,
          variables,

          // optional
          weight,
          // avg_invite_resp_time_in_minutes: {},
          // date: 'string',
          // debug: false,
          // custom_variables: [],
          // inv_start_ratio: {},
          // num_starts: {},
          // num_completes: {},
          // num_invites: {},
          // pstart: {},
          // pcomp: {},
          // start_complete_ratio: {},
        },
      }),
    }),
    // TODO :: proper typing
    getFacts: builder.mutation<any, any>({
      query: ({ panelId, personId }) =>
        `/facts/?panel_id=${panelId}&person_id=${personId}&debug=true`,
    }),
    getHealthcheck: builder.mutation<FeatherstoneHealthcheckAPIResponse, object>({
      query: () => `/healthcheck/`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCountsMutation, useGetFactsMutation, useGetHealthcheckMutation } =
  featherstoneApi;
